// eslint-disable-next-line max-classes-per-file
class ConsentFields {
  constructor(data) {
    this.consentId = data.ci
    this.isCheckbox = data.ic
    this.description = data.d
    this.isRequired = data.r;
    this.value = data.p ? true : 0;
    this.errorMessage = data.em
  }
}
class Form {
  constructor(data) {
    this.id = data.id;
    this.submitted = data.submitted;
    // console.log('FORMSSSSSDDD', data);
    // eslint-disable-next-line no-nested-ternary
    this.newsletterConsentFields = data.ncp
      ? data.ncp
        ? data.ncp.map((x) => new ConsentFields(x))
        : []
      : [];
  }
}

export default Form;
